<agm-map #AgmMap 
  [ngStyle]="{'width': sideLength, 'height': sideLength}"
  (mapReady)="onMapReady($event)" 
  [zoomControl]="true"
  [scrollwheel]="false"
  [streetViewControl]="false">  
</agm-map>